// extracted by mini-css-extract-plugin
module.exports = {"vWhite":"#fff","vUiHueLighter":"#fafafa","vUiHueDark":"#ccc","vRaised":"0 1px 1px 0 rgba(0, 0, 0, 0.1)","button":"FolderPickerButton__button___ZmD3O"};